/**
 * Nsection B15 Service
 * B.15.監控參數說明 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b15';

export interface MonitoringParameterItem {
  id: string;
  data_parameter: string;
  description: string;
  data_unit: string;
  equations_referred: string;
  purpose_baseline: boolean;
  purpose_project: boolean;
  purpose_leakage: boolean;
  measurement_frequency: string;
  measurement_methods: string;
  responsible_entity: string;
  instrument_type: string;
  accuracy_class: string;
  calibration_requirements: string;
  instrument_location: string;
  qaqc_procedures: string;
  treatment_of_uncertainty: string;
  additional_comments: string;
  b13_ref: {
    source_section: string;
    source_label: string;
    symbol: string;
    para_type: number | null;
    equation_latex: string;
  } | null;
}

export interface NsectionB15Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  parameters: MonitoringParameterItem[] | null;
  reporting_frequency: string | null;
  nsection_b15_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB15Update {
  parameters?: MonitoringParameterItem[];
  reporting_frequency?: string;
}

const nsectionB15Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB15Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB15Update): Promise<NsectionB15Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB15Service;
